import type { KnowledgeItem } from '../types/agents';

export async function fetchUrlText(url: string): Promise<string> {
  try {
    const resp = await fetch(url, { mode: 'cors' });
    const contentType = resp.headers.get('content-type') || '';
    const text = await resp.text();
    if (contentType.includes('application/json')) {
      try { return JSON.stringify(JSON.parse(text), null, 2); } catch { return text; }
    }
    // naive tag strip fallback
    return text.replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<style[\s\S]*?<\/style>/gi, '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
  } catch (e) {
    return `Failed to fetch ${url}: ${e instanceof Error ? e.message : String(e)}`;
  }
}

export function addKnowledge(items: KnowledgeItem[], type: KnowledgeItem['type'], value: string): KnowledgeItem[] {
  const id = `${type}-${Date.now()}-${Math.random().toString(36).slice(2,8)}`;
  const entry: KnowledgeItem = { id, type, value, addedAt: Date.now() };
  return [entry, ...items];
}

export function removeKnowledge(items: KnowledgeItem[], id: string): KnowledgeItem[] {
  return items.filter(k => k.id !== id);
}
